import { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';

import { AppContext } from 'commons-ui';
import { RoleDocument } from 'commons/models/marketingDashboard';

import { dehydrateFormData, hydrateFormData } from '../../utils/formDataParser';
import useService from '../../utils/useService';
import { IRolesFormData } from '../../utils/constants';

const useCreate = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const history = useHistory();
	const { requestCreateRole } = useService();

	const data = hydrateFormData();

	const createRole = async (createdData: RoleDocument) => {
		setShowLoader(true);

		try {
			await requestCreateRole(app.appName, createdData);
			showAlert('Role created successfully', { type: 'success' });
			setShowLoader(false);
			history.goBack();
		} catch (e: any) {
			showAlert(e.response?.data?.error ?? 'Error while creating the role', { type: 'error' });
			setShowLoader(false);
		}
	};

	const handleFormSubmit = (createdData: IRolesFormData) => {
		createRole(dehydrateFormData(createdData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useCreate;
